module.exports = __webpack_public_path__ + "static/media/menu-toggle.5b1d8e31.svg";